import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalComplete({ show, onHide, onHideTask, name, idTask, idUser }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [formComment, setFormComment] = useState(null);

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLog(null);
            setLoading(false);
        }
    }, [show]);

    function complete() {
        axios.post('/api_tracker/task/statusComplete', { ID_Task: idTask, Comment: formComment, ID_User: idUser })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    onHideTask();
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Завершение задачи</div>
                    <div className="text-center mb-3">Подтвердите завершение задачи
                        <br></br>
                        <b>«{name}»</b>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Комментарий</label>
                        <textarea className="form-control" rows="3" onChange={(e) => setFormComment(e.target.value)}></textarea>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="finish" loading={loading} size={'lg'} onClick={() => complete()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ModalComplete;
